import React from 'react';

export var MicIconBig = function MicIconBig(props) {
  return React.createElement(
    "svg",
    {
      "data-qa": "MicIcon",
      xmlns: "http://www.w3.org/2000/svg",
      width: "100%",
      height: "100%",
      preserveAspectRatio: "none",
      viewBox: "0 0 32 32"
    },
    React.createElement("path", {
      d: "M0 16C0 7.16344 7.16344 0 16 0C24.8366 0 32 7.16344 32 16C32 24.8366 24.8366 32 16 32C7.16344 32 0 24.8366 0 16Z",
      fill: props.circleColor
    }),
    React.createElement("path", {
      d: "M16 19C17.66 19 18.99 17.66 18.99 16L19 10C19 8.34 17.66 7 16 7C14.34 7 13 8.34 13 10V16C13 17.66 14.34 19 16 19ZM22.08 16C21.66 16 21.31 16.3 21.25 16.71C20.88 19.32 18.53 21.1 16 21.1C13.47 21.1 11.12 19.33 10.75 16.71C10.69 16.3 10.33 16 9.91998 16C9.39998 16 8.99998 16.46 9.06998 16.97C9.52998 19.94 12.03 22.27 15 22.72V25C15 25.55 15.45 26 16 26C16.55 26 17 25.55 17 25V22.72C19.96 22.29 22.47 19.94 22.93 16.97C23 16.46 22.6 16 22.08 16Z",
      fill: props.iconColor
    })
  );
};